import React, { useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom'; // Dùng useNavigate để chuyển trang

function Login() {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate(); 

  // (DEBUG) Ghi log khi component được render
  console.log('Trang Login đã render.');

  const { username, password } = formData;

  const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  // Hàm này sẽ được gọi khi bạn bấm nút
  const onSubmit = async e => {
    e.preventDefault(); // Ngăn trang tải lại
    
    // (DEBUG) Ghi log khi hàm onSubmit bắt đầu
    console.log('Hàm onSubmit đã được gọi!'); 
    
    setError(''); // Xóa lỗi cũ
    try {
      console.log('Đang gửi yêu cầu đăng nhập...'); // (DEBUG)
      // Gọi API login từ backend
      const res = await api.post('/auth/login', { username, password });
      
      console.log('Đăng nhập thành công:', res.data); // (DEBUG)
      
      // Đăng nhập thành công, res.data chứa { token, user }
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      
      // Chuyển hướng đến Dashboard
      navigate('/dashboard'); 

    } catch (err) {
      // Xử lý lỗi
      console.error('LỖI ĐĂNG NHẬP:', err.response || err); // (DEBUG) Cải thiện log lỗi
      const message = err.response?.data?.message || 'Đăng nhập thất bại. Vui lòng thử lại.';
      setError(message);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
      <h2>Đăng nhập Hệ thống</h2>
      
      {/* Thẻ form này PHẢI CÓ 'onSubmit={onSubmit}' */}
      <form onSubmit={onSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label>Tên đăng nhập:</label>
          <input
            type="text"
            name="username"
            value={username}
            onChange={onChange}
            required
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label>Mật khẩu:</label>
          <input
            type="password"
            name="password"
            value={password}
            onChange={onChange}
            required
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>
        
        {/* Hiển thị lỗi nếu có */}
        {error && <p style={{ color: 'red' }}>{error}</p>}
        
        {/* Nút này PHẢI CÓ 'type="submit"' */}
        <button type="submit" style={{ width: '100%', padding: '10px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}>
          Đăng nhập
        </button>
      </form>
    </div>
  );
}

export default Login;

